// The banner and the modal mount in different parts of MainApp, so a window event connects them without shared state
const OPEN_PLAN_BOOST_ENDING_MODAL_EVENT = 'plan-boost-ending-modal:open'

export const openPlanBoostEndingModal = (): void => {
  window.dispatchEvent(new Event(OPEN_PLAN_BOOST_ENDING_MODAL_EVENT))
}

export const onOpenPlanBoostEndingModal = (listener: () => void): (() => void) => {
  window.addEventListener(OPEN_PLAN_BOOST_ENDING_MODAL_EVENT, listener)
  return () => window.removeEventListener(OPEN_PLAN_BOOST_ENDING_MODAL_EVENT, listener)
}
